import React from "react";
import { inject, observer } from "mobx-react";
import { FormRow, InputError, Select } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { emptyError } from "../../../utils/commonUtils";
import { FEEDBACK_SUBJECTS } from "../../../utils/enums";

const FeedbackSubject = observer(({ FeedbackStore }) => {
  const key = "subject";
  const { feedback, updateError, updateValue, updateIncluded, updateTopic } =
    FeedbackStore;
  const subject = feedback.subject;
  const msgs = useMessageGetter("feedback.form.subject");

  updateIncluded(key, true);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
    updateTopic(value, msgs);
  };

  const handleOnBlur = () => {
    if (!subject.value) updateError(key, emptyError(msgs));
  };

  return (
    <div className="rof-feedbackSubject">
      <FormRow
        label={msgs("label")}
        labelFor={`ROF-${key}`}
        labelId={`rof-feedbackSubject`}
      >
        <Select
          id={`ROF-${key}`}
          name={key}
          value={subject.value}
          onChange={(e) => handleOnChange(e.target.value)}
          onBlur={handleOnBlur}
          invalid={!!subject.error}
          aria-describedby={!!subject.error ? `ROF-${key}-error` : null}
          aria-required={true}
        >
          <option value="">{msgs("option.default")}</option>
          {FEEDBACK_SUBJECTS.map((option) => (
            <option key={option} value={option}>
              {msgs(`option.${option}`)}
            </option>
          ))}
        </Select>
        <InputError
          error={subject.error ? subject.error : null}
          id={`ROF-${key}-error`}
        />
      </FormRow>
    </div>
  );
});

export default inject("FeedbackStore")(FeedbackSubject);
